import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Recursive function to check if the route is authorized
const isAuthorizedRoute = (menuItems, path) => {
  for (const item of menuItems) {
    if (item.path === path) return true;
    if (item.children && isAuthorizedRoute(item.children, path)) return true;
  }
  return false;
};

const PrivateRoute = ({ element: Component, ...rest }) => {
  const sidebarMenu = useSelector(
    (state) => state?.basicConfigReducer?.sidebarMenu || []
  );
  // console.log("sidebarMenu>>>", sidebarMenu);
  const isAuthorized =
    rest.path === "/" || isAuthorizedRoute(sidebarMenu, rest.path);
  // console.log("isAuthorized path>>>", isAuthorized, rest.path);

  return isAuthorized ? Component : <Navigate to="/" />;
};

export default PrivateRoute;
